<template>
  <div class="hello">
    <modal name="alert-msg" transition="pop-out" :width="300" height="auto">
      <div class="box">{{msg}}</div>
    </modal>
    <div class="form-signin">
      <h1 class="text-left">
        <a target="_blank" href="https://www.tokenpocket.pro/">
          <img class="tp-logo" src="../assets/logo.png" alt height="30" />
        </a>

        <span class="ver-algin">EIDOS {{$t('i18nView.eidosTitle')}}</span>

        <span class="lang-switch">
          <a v-if="this.$i18n.locale === 'zh'" @click="changeLang('en')" href="javascript:;">EN</a>
          <a v-else @click="changeLang('zh')" href="javascript:;">中</a>
        </span>
      </h1>
      <h5 class="mb-3 font-weight-normal"></h5>

      <div class="mb-2 text-left">
        <label class>
          {{$t('i18nView.currentAccount')}}:
          <span v-if="currentAccount">
            {{currentAccount}},
            <a
              href="javascript:void(0);"
              @click="logout()"
            >{{$t('i18nView.logout')}}</a>
          </span>
          <a @click="login()" href="javascript:void(0);" v-else>{{$t('i18nView.login')}}</a>
        </label>
      </div>
      <div class="mb-2 text-left">
        <label class>EOS {{$t('i18nView.balance')}}: {{eosBalance}}</label>
      </div>
      <div class="mb-2 text-left">
        <label class>
          EIDOS {{$t('i18nView.balance')}}: {{eidosBalance}}
          <a
            v-if="isMobile"
            href="https://newdex.340wan.com/trade/eidosonecoin-eidos-eos?channel=tokenpocket"
            target="_blank"
          >{{$t('i18nView.trade')}}</a>

          <a
            v-else
            href="https://newdex.vip/trade/eidosonecoin-eidos-eos?channel=tokenpocket"
            target="_blank"
          >{{$t('i18nView.trade')}}</a>

          <a
            class="yas-link"
            href="https://tp-lab.tokenpocket.pro/yas/index.html#/"
            target="_blank"
          >{{$t('i18nView.swapYas')}}</a>
        </label>
      </div>
      <div class="mb-2 text-left">
        <label>
          CPU {{$t('i18nView.used')}}: {{cpuLeft}},
          <a
            target="_blank"
            href="https://rex.tokenpocket.pro/?from=eidos"
          >REX {{$t('i18nView.rent')}}</a>
        </label>
      </div>
      <div class="mb-2 text-left">
        <label>
          CPU {{$t('i18nView.left')}}: {{cpuMS > 1000 ? (parseFloat(cpuMS /1000).toFixed(1) + 's') : (cpuMS + ' ms')}}
          <span
            class="error"
            v-if="cpuMS !== '-' && cpuMS < (0.25 * actionTimes)"
          >{{$t('i18nView.notEnough')}}</span>
        </label>
      </div>
      <div class="mb-2 text-left">
        <label class>NET {{$t('i18nView.used')}}: {{netLeft}}</label>
      </div>

      <!-- <p
        class="text-muted text-left"
      >*{{$t('i18nView.contract')}} {{$t('i18nView.ram')}} {{$t('i18nView.used')}}: {{contractRam}}, {{$t('i18nView.contractRamTip')}}</p>-->

      <p class="text-muted text-left">{{$t('i18nView.digTime')}}: {{digCount}}</p>

      <p class="mykey-tip" v-if="isMyKey || isMeet">
        本工具已无法在当前环境使用，请到官网tokenpocket.pro下载
        <a
          href="https://www.tokenpocket.pro/?from=mykey"
        >TokenPocket 钱包</a> 体验急速低耗的挖矿功能。
      </p>
      <div v-else>
        <button
          class="btn mb-3 btn-primary btn-block"
          v-if="!isAuto"
          type="button"
          @click="startAuto()"
        >{{$t('i18nView.enableAuto')}} 0.0001 EOS</button>

        <button
          class="btn mb-3 btn-danger btn-block"
          @click="stop()"
          v-else
        >{{$t('i18nView.stopAuto')}}</button>
      </div>

      <div class="text-left log-area">
        <p v-for="log in logList" class="log-item">{{log}}</p>
      </div>

      <p class="text-muted text-left mining-tips">{{$t('i18nView.miningTips')}}</p>

      <div class="settings">
        <h2>{{$t('i18nView.advSetting')}}</h2>
        <p class="small-tip">{{$t('i18nView.settingTips')}}</p>
        <p class="text-left setting-item">
          {{$t('i18nView.diggingSetting')}}
          <input
            type="text"
            style="width:60px"
            @blur="recordSetting"
            v-model="settingAmount"
          />
          {{$t('i18nView.diggingSetting1')}}
          <br />
          <span class="setting-tip">{{$t('i18nView.digTip')}} {{predictAmount}}</span>
        </p>
        <p class="text-left setting-item">
          {{$t('i18nView.cpuQuota')}}
          <input
            type="text"
            @blur="recordCpuQuota"
            v-model="cpuQuota"
            style="width:60px"
          /> %
          <br />
          <span class="setting-tip">{{$t('i18nView.cpuQuotaTip')}}</span>
        </p>

        <p class="text-left setting-item">
          {{$t('i18nView.actionsPerTx')}}
          <select
            style="width:60px"
            v-model="actionTimes"
            @change="changeX()"
          >
            <option :value="times.value" v-for="times in actionTimesList">{{times.name}}</option>
          </select>
          <br />
          <span class="setting-tip">{{$t('i18nView.actionsPerTxTip')}}</span>
        </p>

        <!-- <p class="text-left setting-item">
          <label>
            {{$t('i18nView.bpBlocker')}}
            <input
              type="checkbox"
              v-model="isBpBlockerOn"
              @change="changeBpBlocker()"
            />
          </label>
          <br />

          <span class="setting-tip">{{$t('i18nView.bpBlockerTip')}}</span>
        </p>-->

        <!-- <p class="text-left setting-item" v-if="!isFirstTime && isAuto"> -->
        <!-- <p class="text-left setting-item">
          <label>
            {{$t('i18nView.fastMode')}}
            <input
              id="fast-switch"
              v-model="isFast"
              type="checkbox"
              @change="handleFast"
            />
          </label>
          <br />

          <span class="setting-tip">{{$t('i18nView.fastModeTip')}}</span>
        </p>-->
      </div>

      <!-- <p class="text-muted text-left">*{{$t('i18nView.whiteTip')}}.</p> -->
      <!-- <p class="text-muted text-left">{{$t('i18nView.airgrabTip')}}.</p> -->

      <p class="text-muted node-options">
        <input
          class="form-control form-control-sm"
          type="text"
          style="width: 240px; display:inline-block; padding:2px 4px; margin-right:4px;"
          v-model="currentEndpoint"
        />
        <span
          :class="parseInt(delayTime) < 200 ? 'green' : parseInt(delayTime) > 800 ? 'red' : 'yellow'"
        >{{delayTime}}</span>

        <br />
        <button class="btn btn-sm btn-primary" @click="updateNode()">{{$t('i18nView.changeNode')}}</button>

        <button class="btn btn-sm btn-primary" @click="randomNode()">{{$t('i18nView.randomNode')}}</button>
      </p>
    </div>
  </div>
</template>

<script>
import Eos from "eosjs";
import ScatterJS from "scatterjs-core";
import ScatterEOS from "scatterjs-plugin-eosjs";
import { Settings } from "luxon";
import dayjs from "dayjs";

ScatterJS.plugins(new ScatterEOS());

// var hosts = ["api.main.alohaeos.com", "eos.newdex.one", "api.eosdetroit.io"];
var hosts = [
  "node.betdice.one",
  "api-mainnet.starteos.io",
  "api.eosnewyork.io",
  "api.main.alohaeos.com",
  "api.eosdetroit.io"
];

window.bp_blocker = false;
window.info_update_time = new Date().getTime();

var index = Math.floor(Math.random() * hosts.length);

let network = {
  blockchain: "eos",
  host: hosts[index],
  port: 443,
  protocol: "https",
  chainId: "aca376f206b8fc25a6ed44dbdc66547c36c6c33e3a119ffbeaef943642f0e906"
};

let requiredFields = { accounts: [network] };

let eosClient = null;

export default {
  name: "HelloWorld",
  data() {
    return {
      currentAccount: null,
      currentPermission: null,
      readOnlyEos: null,
      isFirstTime: true,
      eosBalance: "",
      eidosBalance: "",
      isAuto: false,
      cpuLeft: "",
      cpuMS: "-",
      cpuTotalMS: 100,
      cpuUsedMS: 1,
      netLeft: "",
      contractRam: "",
      contractCpu: "",
      contractAmount: "",
      predictAmount: "",
      logList: ["~"],
      msg: "",
      isFast: true,
      digCount: 0,
      currentEndpoint: "",
      isMyKey: false,
      isMeet: false,
      settingAmount: 0,
      cpuQuota: 0,
      isMobile: true,
      actionTimes: 5,
      delayTime: "-ms",
      isBpBlockerOn: false,
      actionTimesList: [
        {
          value: 1,
          name: "1x"
        },
        {
          value: 5,
          name: "5x"
        },
        {
          value: 10,
          name: "10x"
        },
        {
          value: 20,
          name: "20x"
        },
        {
          value: 50,
          name: "50x"
        },
        {
          value: 100,
          name: "100x"
        }
      ]
    };
  },
  created() {
    this.isMobile =
      navigator.userAgent
        .toLowerCase()
        .match(
          /(ipod|iphone|android|coolpad|tokenpocket|mmp|smartphone|midp|wap|xoom|j2me|blackberry)/i
        ) != null;
    let chainId = network.chainId;
    let httpEndpoint =
      network.protocol + "://" + network.host + ":" + network.port;

    this.currentEndpoint = network.protocol + "://" + network.host;

    this.readOnlyEos = Eos({
      chainId,
      httpEndpoint
    });

    this.checkDelay();

    this.settingAmount = parseFloat(
      localStorage.getItem("amount-setting") || 0
    );
    this.cpuQuota = parseFloat(localStorage.getItem("cpu-quota") || 0);
    this.digCount = +localStorage.getItem("dig-count");

    if (
      localStorage.getItem("action-times") &&
      +localStorage.getItem("action-times") === 200 &&
      +localStorage.getItem("action-times") === 150
    ) {
      localStorage.setItem("action-times", 100);
    }

    this.actionTimes = parseInt(localStorage.getItem("action-times") || 5);

    ScatterJS.scatter.connect("eidos").then(connected => {
      // User does not have Scatter Desktop, Mobile or Classic installed.
      if (!connected) return false;

      this.scatter = ScatterJS.scatter;

      this.login();
    });

    if (navigator.userAgent.toLowerCase().indexOf("mykey") > -1) {
      this.isMyKey = true;
    }

    if (navigator.userAgent.toLowerCase().indexOf("meet.one") > -1) {
      this.isMeet = true;
    }
  },
  methods: {
    login() {
      this.scatter
        .getIdentity(requiredFields)
        .then(() => {
          const account = this.scatter.identity.accounts[0];

          let scatter = this.scatter;

          this.pubKey = this.scatter.identity.publicKey;

          eosClient = this.scatter.eos(network, Eos);

          this.currentAccount = account.name;
          this.currentPermission = account.authority;

          if (_hmt) {
            try {
              _hmt.push([
                "_trackEvent",
                "LoginEidos",
                this.currentAccount || "-"
              ]);
            } catch (err) {
              console.log(err);
            }
          }

          this.queryBalanceInit();

          this.infoTimer();
        })
        .catch(err => {
          // alert(JSON.stringify(err));
        });
    },
    recordSetting() {
      localStorage.setItem("amount-setting", this.settingAmount);
    },
    changeX() {
      localStorage.setItem("action-times", this.actionTimes);
    },
    changeBpBlocker() {
      window.bp_blocker = this.isBpBlockerOn;
      if (this.isBpBlockerOn) {
        this.isFast = false;
      }
    },
    handleFast() {
      if (this.isFast) {
        window.bp_blocker = false;
        this.isBpBlockerOn = false;
        if (this.fastTimer) {
          clearInterval(this.fastTimer);
        }

        this.fastTimer = setInterval(() => {
          this.transfer();
        }, 5000);
      } else {
        clearInterval(this.fastTimer);
      }
    },
    logout() {
      this.scatter.forgetIdentity();

      this.isAuto = false;
      this.currentAccount = "";
      this.currentPermission = "";
      this.cpuLeft = "";
      this.netLeft = "";
      this.eidosBalance = "";
      this.eosBalance = "";
      this.cpuMS = "-";
      this.cpuTotalMS = 100;
    },
    infoTimer() {
      setInterval(() => {
        if (
          window.bp_blocker &&
          this.isAuto &&
          window.info_update_time + 1000 < new Date().getTime()
        ) {
          this.readOnlyEos.getInfo({}).then(res => {
            window.info_update_time = window.block_producer_time = new Date(
              res.head_block_time + "Z"
            ).getTime();

            if (window.block_producer !== res.head_block_producer) {
              window.block_producer_time = new Date(
                res.head_block_time + "Z"
              ).getTime();
            }

            window.block_producer = res.head_block_producer;
          });
        }
      }, 1000);
    },
    checkDelay() {
      var now = new Date().getTime();
      this.readOnlyEos.getInfo({}).then(res => {
        this.delayTime = parseInt(new Date().getTime() - now) + "ms";
      });
    },
    randomNode() {
      var index = Math.floor(Math.random() * hosts.length);

      let network = {
        blockchain: "eos",
        host: hosts[index],
        port: 443,
        protocol: "https",
        chainId:
          "aca376f206b8fc25a6ed44dbdc66547c36c6c33e3a119ffbeaef943642f0e906"
      };

      eosClient = this.scatter.eos(network, Eos);

      let httpEndpoint =
        network.protocol + "://" + network.host + ":" + network.port;

      this.currentEndpoint = network.protocol + "://" + network.host;

      this.readOnlyEos = Eos({
        chainId: network.chainId,
        httpEndpoint
      });

      this.addLog(this.$t("i18nView.nodeChanged"));

      this.checkDelay();
    },
    updateNode() {
      var endpoint = this.currentEndpoint;
      var endArr = this.currentEndpoint.split("://");
      var protocol = endArr.length === 2 ? endArr[0] : "https";

      var mainDomain = endArr.length === 2 ? endArr[1] : endArr[0];

      if (mainDomain.match("/")) {
        mainDomain = mainDomain.split("/")[0];
      }
      var end1Arr = mainDomain.split(":");

      network = {
        blockchain: "eos",
        host: end1Arr[0],
        port: end1Arr[1] ? end1Arr[1] : protocol === "https" ? 443 : 80,
        protocol: protocol,
        chainId:
          "aca376f206b8fc25a6ed44dbdc66547c36c6c33e3a119ffbeaef943642f0e906"
      };
      // this.login();

      eosClient = this.scatter.eos(network, Eos);

      let httpEndpoint =
        network.protocol + "://" + network.host + ":" + network.port;

      this.readOnlyEos = Eos({
        chainId: network.chainId,
        httpEndpoint
      });

      this.addLog(this.$t("i18nView.nodeChanged"));

      this.checkDelay();
    },
    changeLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("locale", lang);
      if (lang === "en") {
        Settings.defaultLocale = "en-US";
      } else {
        Settings.defaultLocale = "zh-CN";
      }
    },
    startAuto() {
      this.isAuto = true;
      this.isFast = true;

      this.transfer("start");
    },
    recordCpuQuota() {
      localStorage.setItem("cpu-quota", this.cpuQuota);
    },
    addLog(log) {
      if (this.logList.length > 100) {
        this.logList = [];
      }

      this.logList.unshift(
        "~ [" + dayjs(new Date()).format("HH:mm:ss") + "] " + log
      );
    },
    transfer(option) {
      if (this.isFirstTime) {
        setTimeout(() => {
          if (this.isFirstTime) {
            this.isFirstTime = false;
            this.handleFast();
          }
        }, 10000);
      }

      console.log("transfer");
      this.addLog(this.$t("i18nView.startTransfer"));
      if (this.currentAccount) {
        // 判断预期获得多少
        if (
          parseFloat(this.predictAmount) < parseFloat(this.settingAmount) ||
          (+this.cpuQuota !== 0 &&
            parseFloat(this.cpuLeft) > parseFloat(this.cpuQuota))
        ) {
          // if (option === "start") {
          //   setTimeout(() => {
          //     this.transfer("start");
          //   }, 5000);
          // }
          this.addLog(this.$t("i18nView.noMatch"));
          return;
        }

        // 最后开关
        if (!this.isAuto) {
          return;
        }

        var actions = [];
        for (var i = 0; i < +this.actionTimes; i++) {
          actions.push({
            account: "eosio.token",
            name: "transfer",
            authorization: [
              {
                actor: this.currentAccount,
                permission: this.currentPermission
              }
            ],
            data: {
              from: this.currentAccount,
              to: "eidosonecoin",
              quantity: "0.0001 EOS",
              memo: "love from tp"
            }
          });
        }

        // console.log("try to transfer");

        try {
          eosClient
            .transaction({
              actions: actions
            })
            .then(res => {
              this.addLog(this.$t("i18nView.success"));
              if (this.isFirstTime) {
                this.isFirstTime = false;
                this.handleFast();
              }

              this.digCount = this.digCount + this.actionTimes;
              localStorage.setItem("dig-count", this.digCount);

              if (this.isAuto && !this.isFast) {
                // console.log("下一次");
                this.transfer("start");
              }
            })
            .catch(err => {
              this.addLog(this.$t("i18nView.failed"));
              if (this.isFirstTime) {
                this.isFirstTime = false;
                this.handleFast();
              }

              if (this.isAuto && !this.isFast) {
                setTimeout(() => {
                  this.transfer("start");
                }, 2000);
              }

              if (typeof err === "string") {
                try {
                  let errJson = JSON.parse(err);
                  if (
                    errJson.error &&
                    errJson.error.name &&
                    errJson.error.name === "tx_cpu_usage_exceeded"
                  ) {
                    this.addLog(this.$t("i18nView.cpuNotEnough"));
                  }
                } catch (e) {}
              }
            });
        } catch (err) {
          console.log("转账失败");
          if (this.isAuto && !this.isFast) {
            setTimeout(() => {
              console.log("失败重试");
              this.transfer("start");
            }, 2000);
          }
        }
      }
    },
    queryBalanceInit() {
      if (this.currentAccount) {
        if (!this.balanceTimer) {
          this.queryBalance();
          this.queryState();

          this.balanceTimer = setInterval(() => {
            this.queryBalance();
          }, 10000);

          this.stateTimer = setInterval(() => {
            this.queryState();
          }, 20000);
        }
      }
    },
    handleError(err) {
      if (typeof err === "string") {
        try {
          let errJson = JSON.parse(err);
          if (errJson.error && errJson.error.details.length) {
            if (
              errJson.error.name !== "tx_duplicate" &&
              errJson.error.name !== "expired_tx_exception"
            ) {
              this.msg =
                this.$t("i18nView.error") + errJson.error.details[0].message;
              this.$modal.show("alert-msg");
            }
          } else if (errJson.error) {
            this.msg = this.$t("i18nView.error") + errJson.error.what;
            this.$modal.show("alert-msg");
          } else {
            this.msg =
              this.$t("i18nView.error") + errJson.message ||
              errJson.code ||
              errJson.msg;
            this.$modal.show("alert-msg");
          }
        } catch (e) {
          this.msg = this.$t("i18nView.error") + e;
          this.$modal.show("alert-msg");
        }
      } else {
        this.msg =
          this.$t("i18nView.error") + err.message || err.type || err.code;
        this.$modal.show("alert-msg");
      }
    },
    stop() {
      this.isAuto = false;
      clearInterval(this.fastTimer);
    },

    queryState() {
      if (this.currentAccount) {
        this.readOnlyEos
          .getCurrencyBalance("eosio.token", this.currentAccount, "EOS")
          .then(res => {
            this.eosBalance = res[0];
          });

        this.readOnlyEos
          .getCurrencyBalance("eidosonecoin", this.currentAccount, "EIDOS")
          .then(res => {
            this.eidosBalance = res[0];
          });

        this.readOnlyEos.getAccount(this.currentAccount).then(res => {
          this.cpuLeft =
            parseFloat((res.cpu_limit.used / res.cpu_limit.max) * 100).toFixed(
              2
            ) + "%";

          this.cpuMS = parseFloat(res.cpu_limit.available / 1000).toFixed(1);
          this.cpuTotalMS =
            res.cpu_limit.max / 1000 > 1000
              ? parseFloat(res.cpu_limit.max / 1000000).toFixed(1) + "s"
              : parseFloat(res.cpu_limit.max / 1000).toFixed(1) + "ms";
          this.cpuUsedMS =
            res.cpu_limit.used / 1000 > 1000
              ? parseFloat(res.cpu_limit.used / 1000000).toFixed(1) + "s"
              : parseFloat(res.cpu_limit.used / 1000).toFixed(1) + "ms";

          this.netLeft =
            parseFloat((res.net_limit.used / res.net_limit.max) * 100).toFixed(
              2
            ) + "%";
        });
      }

      // this.readOnlyEos.getAccount("eidosonecoin").then(res => {
      //   this.contractRam =
      //     parseFloat((res.ram_usage / res.ram_quota) * 100).toFixed(2) + "%";

      //   this.contractCpu =
      //     parseFloat((res.cpu_limit.used / res.cpu_limit.max) * 100).toFixed(
      //       2
      //     ) + "%";
      // });
    },
    queryBalance() {
      if (this.currentAccount) {
        this.readOnlyEos
          .getCurrencyBalance("eidosonecoin", "eidosonecoin", "EIDOS")
          .then(res => {
            this.contractAmount = res[0];
            this.predictAmount =
              parseFloat(parseFloat(res[0]) / 10000).toFixed(4) + " EIDOS";
          });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="less">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.tp-logo {
  height: 30px;
}
label {
  margin-bottom: 3px;
  font-size: 13px;
}

select {
  background-color: #fff;
  border: none;
}

.ver-algin {
  vertical-align: middle;
  display: inline-block;
}
.tp-logo {
  vertical-align: middle;
}

h1 {
  font-size: 15px;
  line-height: 1.5;
}
.small-tip {
  font-size: 12px;
  color: #999;
  text-align: left;
}

.v--modal-box {
  padding: 20px !important;
  color: #d63d52;
}

.mykey-tip {
  padding: 20px;
  background: #eee;
}

.settings {
  padding: 10px;
  background: #fafafa;
  margin-bottom: 8px;
}

.setting-item {
  padding-left: 8px;
  border-left: 4px solid #e4f1ff;

  .setting-tip {
    font-size: 12px;
    color: #777;
  }
}

.error {
  color: #f54141;
}

.form-signin {
  position: relative;
}
span.green {
  color: #42b983;
}
span.red {
  color: #f54141;
}
span.yellow {
  color: #e88e1e;
}

.lang-switch {
  position: absolute;
  right: 10px;
  top: 20px;
  border: 1px solid #ddd;
  text-decoration: none;
  padding: 2px 4px;
  border-radius: 4px;
  font-size: 12px;

  a {
    text-decoration: none;
  }
}

.node-options {
  button {
    margin: 8px;
  }
}

.log-area {
  width: 100%;
  padding: 4px 8px;
  box-sizing: border-box;
  height: 70px;
  overflow: auto;
  border-radius: 4px;
  background: #333;
  color: #39b32c;
  font-family: monospace;
  box-shadow: 0 0 4px 4px #272727 inset;
}
.log-item {
  margin: 0;
}

.mining-tips {
  margin-top: 8px;
}

.yas-link {
  margin-left: 12px;
}

input[type="checkbox"] {
  vertical-align: middle;
}

p {
  font-size: 13px;
}
</style>
